import React from "react";
import { Control, FieldValues, FormState, UseFormRegister, UseFormSetValue } from "react-hook-form";
import { FormContainer } from "../../../../../../../../../shared/form/form.styles";
import PassportForm from "../shared/PassportForm";
import PersonalForm from "../shared/PersonalForm";
import ResidingPlaceForm from "./ResidingPlaceForm";
import DegreeType from "../../../../../../../../../../core/types/degreeType";

const PhysicalPerson: React.FC<{
  register: UseFormRegister<FieldValues>;
  formState: FormState<FieldValues>;
  control: Control;
  setValue: UseFormSetValue<FieldValues>;
  degree: DegreeType;
}> = (props) => {
  const { degree, ...otherProps } = props;
  return (
    <FormContainer leftContent noScrollContent>
      <PersonalForm
        {...otherProps}
        sectionTitle="Личные данные"
        showINN={degree === "additional"}
        showEmail
      />
      <PassportForm {...otherProps} />
      <ResidingPlaceForm {...otherProps} />
    </FormContainer>
  );
};

export default PhysicalPerson;
